// eslint-disable-next-line global-require
// const api = (process.env.NODE_ENV === 'prod') ? require('./api') : require('./mockApi');
const api = require('./api');

console.log(`Using ${process.env.NODE_ENV === 'prod' ? '' : 'dummmy '}api implementation`, api);

export default api.default;



// WEBPACK FOOTER //
// ./src/api/index.js